namespace Pages {
    export class ImportPage {
        private readonly _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }
        async index() {
            return new PageViewResult("Import/", {});
        }

    }
}